export default __webpack_public_path__ + "static/media/Untitled1.6792da14.jpg";